import React, { useState } from "react";
import styles from "./style.module.css";

const ToggleSwitch = ({ checked, index, onChange, extraPrm }) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleChange = (e) => {
    let tempChecked = e.target.checked;
    setIsChecked(tempChecked);
    onChange(index, tempChecked, extraPrm);
  };

  return (
    <label className={styles.toggle_switch}>
      <input type="checkbox" checked={isChecked} onChange={handleChange} />
      <span className={styles.slider}></span>
    </label>
  );
};

export default ToggleSwitch;
